module.exports = __webpack_public_path__ + "d3f76c435773d41a917f841f10252bbb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-5.png
// module id = 1684
// module chunks = 0